import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-gou",
  "use": "icon-gou-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-gou\"><defs><style type=\"text/css\"></style></defs><path d=\"M395.106182 628.896568 174.683743 408.474128 64.451232 518.706639 395.012767 849.268175 408.474128 835.806814 408.567543 835.900229 959.503436 284.964336 849.270925 174.731825 395.106182 628.896568Z\" p-id=\"8520\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/global/gou.svg
// module id = K6NV
// module chunks = 55